/* eslint-disable no-shadow */

export enum GENERIC_PROCEDURE_STATUS {
  PENDING_DOCUMENTATION = 'PENDING_DOCUMENTATION',
  REVIEW_PENDING_DOCUMENTATION = 'REVIEW_PENDING_DOCUMENTATION',
  PRESENTED_TO_AGENCY = 'PRESENTED_TO_AGENCY',
  PRESENTED_TO_DGT = 'PRESENTED_TO_DGT',
  FINISHED_BY_DGT = 'FINISHED_BY_DGT',
  CANCELED = 'CANCELED',
  DOCS_AT_OFFICE = 'DOCS_AT_OFFICE',
  DOCS_SENT = 'DOCS_SENT',
  DOCS_DELIVERED = 'DOCS_DELIVERED',
}

export const GENERIC_PROCEDURE_STATUS_PRO: {
  [key: string]: GENERIC_PROCEDURE_STATUS[];
} = {
  CANCELED: [GENERIC_PROCEDURE_STATUS.CANCELED],
  NOT_SUBMITTED: [GENERIC_PROCEDURE_STATUS.PENDING_DOCUMENTATION],
  SUBMITTED_TO_AGENCY: [
    GENERIC_PROCEDURE_STATUS.REVIEW_PENDING_DOCUMENTATION,
    GENERIC_PROCEDURE_STATUS.PRESENTED_TO_AGENCY,
  ],
  SUBMITTED_TO_DGT: [GENERIC_PROCEDURE_STATUS.PRESENTED_TO_DGT],
  FINISHED_BY_DGT: [
    GENERIC_PROCEDURE_STATUS.FINISHED_BY_DGT,
    GENERIC_PROCEDURE_STATUS.DOCS_AT_OFFICE,
    GENERIC_PROCEDURE_STATUS.DOCS_SENT,
    GENERIC_PROCEDURE_STATUS.DOCS_DELIVERED,
  ],
};

export const SHIPMENT_STATUS = {
  SENT: [GENERIC_PROCEDURE_STATUS.DOCS_SENT],
  DELIVERED: [GENERIC_PROCEDURE_STATUS.DOCS_DELIVERED],
};
